/**
 * Shared types for the file import system.
 */

export interface ParsedFileResult {
  headers: string[];
  sampleRows: Record<string, string>[];
  totalRows: number;
  columnMappings: ColumnMapping[];
  coordinateFormat: "separate" | "combined";
  coordinateSourceColumns: string[];
  sportTypeMappings: SportTypeMapping[];
  validationIssues: ValidationIssue[];
  sheetNames?: string[];
  selectedSheet?: string;
  fileType: "csv" | "xlsx" | "shp";
}

export interface ColumnMapping {
  sourceHeader: string;
  targetColumn: string | null;
  confidence: number;
}

export interface ValidationIssue {
  row?: number;
  column?: string;
  message: string;
  severity: "error" | "warning";
}

export interface SportTypeMapping {
  originalValue: string;
  mappedValue: string | null;
  isFallback: boolean;
}

export interface AddressConfig {
  addressColumn: string | null;
  cityColumn: string | null;
  stateColumn: string | null;
  zipColumn: string | null;
}

export type WizardStep = "upload" | "mapping" | "address" | "preview" | "results";

export interface GeocodeFailure {
  row: number;
  address: string;
  reason: string;
}

export interface ImportResult {
  localUpserted: number;
  prodUpserted: number | null;
  matchesFound: number | null;
  errors: string[];
  skippedRows: number;
  totalRows: number;
  geocodedCount?: number;
  geocodeFailures?: GeocodeFailure[];
  locationIds?: string[];
}

export type TargetColumn =
  | "name"
  | "lat"
  | "lng"
  | "country"
  | "city"
  | "hub"
  | "location_type"
  | "sport_court_type"
  | "tiering"
  | "typology"
  | "visibility"
  | "accessibility"
  | "number_of_courts"
  | "address"
  | "zip_code"
  | "municipality"
  | "ownership"
  | "comments"
  | "notes";

export const TARGET_COLUMNS: TargetColumn[] = [
  "name",
  "lat",
  "lng",
  "country",
  "city",
  "hub",
  "location_type",
  "sport_court_type",
  "tiering",
  "typology",
  "visibility",
  "accessibility",
  "number_of_courts",
  "address",
  "zip_code",
  "municipality",
  "ownership",
  "comments",
  "notes",
];
